var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgNews16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1906 0.577515H0V12.3396C0 15.1011 2.23857 17.3396 4.99999 17.3396H13.7145V17.3395C14.9768 17.3394 16 16.3161 16 15.0537V8.33504C16 7.83774 15.5969 7.4346 15.0996 7.4346H14.8571C14.2259 7.4346 13.7143 7.94628 13.7143 8.57747V12.7838C13.7059 13.1974 13.3681 13.5301 12.9525 13.5301C12.5317 13.5301 12.1906 13.1889 12.1906 12.7681V9.72049L12.1906 9.71288V0.577515ZM5.33324 2.10149H1.52367V6.67298H5.33324V2.10149ZM1.52367 8.19669H10.6666V9.72052H1.52367V8.19669ZM10.6666 11.2443H1.52367V12.7682H10.6666V11.2443ZM10.6668 2.10149H6.85725V3.62532H10.6668V2.10149ZM6.85725 5.14904H10.6668V6.67287H6.85725V5.14904Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNews16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;